// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"616432de","453":"909aeac4","455":"e38afa93","977":"3c4a75ac"}[chunkId] + ".chunk.js";
};